import styled from "styled-components";

export const ResultCardItem = styled.li`
  border-top: 1px solid ${(props) => props.theme.colors.border};
`;

export const ItemRadioBox = styled.div`
  width: 20px;
  height: 20px;
  border: 1px solid ${(props) => props.theme.colors.inputBorder};
  border-radius: 50%;

  svg {
    display: none;
  }
`;

export const ItemTextBox = styled.div`
  display: flex;
  color: ${(props) => props.theme.colors.text3};
  font-size: 1.6rem;
  flex-direction: column;
  gap: 6px;
`;

export const ItemLabel = styled.label`
  display: flex;
  height: 80px;
  padding: 0 14px;
  align-items: center;
  gap: 14px;

  input {
    display: none;
  }

  &:has(input:checked) {
    background: ${(props) => props.theme.colors.primary5};

    ${ItemRadioBox} {
      border: none;

      svg {
        display: block;
      }
    }

    ${ItemTextBox} {
      color: ${(props) => props.theme.colors.primary100};
      font-weight: 800;
    }
  }
`;

export const ItemUID = styled.div`
  color: ${(props) => props.theme.colors.inputLabel};
  font-size: 1.2rem;
  font-weight: 300;
`;
